// == Import npm
import React from "react";
import { Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

// == Import SCSS
import "./Loader.less";

// == Import assets

// == import i18n
import { useTranslation } from "react-i18next";

const Loader = () => {
  const [t] = useTranslation();

  return (
    <div className="globalLoader">
    <div>
      <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
      <br />
      <Typography.Title level={3}>{t("Loading")}...</Typography.Title>
    </div>
  </div>
  );
};

export default Loader;
